<template>
  <div id="tasks">
    <el-row :gutter="40">
      <el-col :lg="16" :md="24">
        <el-row class="header-row">
          <h3 class="el-page-header">Processes</h3>
        </el-row>

        <el-popover placement="right" ref="newProcessPopover" title="New Process" width="300" trigger="click">
          <el-form :model="addProjectProcessForm" ref="addProjectProcessForm" size="mini" :rules="addProjectProcessForm.rules" label-position="top" label-width="180px" @submit.native.prevent>
            <el-form-item prop="name" label="Process Name">
              <el-input v-model="addProjectProcessForm.name" size="mini"></el-input>
            </el-form-item>
            <el-form-item prop="description" label="Description">
              <el-input v-model="addProjectProcessForm.description" size="mini"></el-input>
            </el-form-item>
            <el-form-item style="text-align: center;">
              <el-button-group>
                <el-button class="hiaButton" plain round size="mini" type="text" @click="closeNewProcessPopover()">Cancel</el-button>
                <el-button class="hiaButton" plain round size="mini" @click="addProcess('addProjectProcessForm')">Add</el-button>
              </el-button-group>
            </el-form-item>
          </el-form>

          <el-button class="hiaButton" slot="reference" plain round size="mini" icon="el-icon-plus">Add Process</el-button>
        </el-popover>

        <v-client-table class="hiaTable topMargin" v-loading="loading" element-loading-spinner="atom-audit-loader" ref="projectProcessListsGrid" id="projectProcessListsGrid" :data="projectProcessesList" :columns="processColumns" :options="processOptions">
          <div slot="filter__inactive">
            <input type="checkbox" @change="$refs.projectProcessListsGrid.setFilter({ inactive: $event.target.checked })" />
          </div>
          <template slot="drilldown" slot-scope="props">
            <span class="drilldown-cell">
              <span class="drilldown-toggle" @click="drilldown(props)" title="Expand or collapse">
                <i class="mdi" :class="props.row.selected ? 'mdi-minus-box-outline' : 'mdi-plus-box-outline'" style="font-size: 15px; position: relative; top: 1px;"></i>
              </span>
              <el-tag size="mini" type="primary" class="drilldown-tag" @click.native="openManageTasks(props)"> Manage Tasks ({{ (props.row.projectTasks || []).length }}) </el-tag>
            </span>
          </template>
          <template slot="child_row" slot-scope="props">
            <projectTasksNew style="padding-right: 20px; padding-left: 20px; padding-bottom:20px; margin-top: -10px;" :selectedProcess="props.row"></projectTasksNew>
          </template>
          <template slot="name" slot-scope="props">
            <div class="el-input--mini">
              <input class="el-input__inner" type="text" v-model="props.row.name" @change="updateProcess(props.row)" />
            </div>
          </template>
          <template slot="description" slot-scope="props">
            <div class="el-input--mini">
              <input class="el-input__inner" type="text" v-model="props.row.description" @change="updateProcess(props.row)" />
            </div>
          </template>
          <template slot="inactive" slot-scope="props">
            <input :key="props.row.processId" type="checkbox" v-model="props.row.inactive" @change="updateProcess(props.row)" />
          </template>
          <template slot="delete" slot-scope="props">
            <div style="text-align: center;">
              <i class="el-icon-close delete-button" @click="deleteProcess(props.row)"></i>
            </div>
          </template>
        </v-client-table>
      </el-col>
      <el-col v-if="1 === 0" :span="12">
        <projectTasksNew></projectTasksNew>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import HiaAuthorization from '@/mixins/hiaAuthorization'
  import hiaTable from '@/mixins/hiaTable'
  import projectTasksNew from './projectTasksNew'

  export default {
    name: 'taskTab',
    mixins: [hiaTable, HiaAuthorization],
    props: [],
    data() {
      return {
        loading: false,
        processColumns: ['drilldown', 'name', 'description', 'inactive', 'delete'],
        processOptions: {
          showChildRowToggler: false,
          uniqueKey: 'processId',
          filterByColumn: true,
          sortable: ['name'],
          headings: {
            delete: function(h) {
              return ''
            },
            drilldown: 'Tasks',
            name: 'Process Name'
          },
          perPage: 10,
          texts: {
            filter: '',
            filterBy: '...'
          },
          highlightMatches: true,
          sortIcon: { is: 'none' }
        },
        showAddProjectProcessForm: false,
        addProjectProcessForm: {
          name: '',
          order: '',
          rules: {
            name: [{ required: true, message: 'Please Input Name', trigger: 'none' }],
            order: [{ required: true, message: 'Please Input Order', trigger: 'none' }]
          }
        }
      }
    },
    components: {
      projectTasksNew
    },
    methods: {
      ...mapActions('managedLists/projectProcesses/', ['GET_PROJECT_PROCESSES', 'POST_PROJECT_PROCESS', 'DELETE_PROJECT_PROCESS', 'PUT_PROJECT_PROCESS']),
      ...mapActions('managedLists/projectTasks/', ['GET_PROJECT_TASKS']),
      ...mapMutations('managedLists/projectProcesses/', ['SET_SELECTED']),
      ...mapMutations('dropdowns/', ['REMOVE_CACHED_DROPDOWN']),
      async initialize(route) {
        this.loading = true
        await Promise.all([this.GET_PROJECT_TASKS(), this.GET_PROJECT_PROCESSES()])
        this.loading = false
      },
      closeNewProcessPopover() {
        const popper = this.$refs.newProcessPopover
        if (popper) {
          popper.doDestroy()
          popper.doClose()
        }
      },
      drilldown(props) {
        props.row.selected = !props.row.selected
        const index = this.projectProcessesList.findIndex(x => x.processId === props.row.processId)
        this.$set(this.projectProcessesList, index, props.row)

        this.$refs.projectProcessListsGrid.toggleChildRow(props.row.processId)
      },
      openManageTasks(props) {
        if (!props.row.selected) {
          props.row.selected = true
          const index = this.projectProcessesList.findIndex(x => x.processId === props.row.processId)
          this.$set(this.projectProcessesList, index, props.row)
          this.$refs.projectProcessListsGrid.toggleChildRow(props.row.processId)
        }
      },
      addProcess(refName) {
        this.$refs[refName].validate(async valid => {
          if (valid) {
            try {
              this.loading = true

              const payload = {
                process: {
                  name: this.addProjectProcessForm.name,
                  description: this.addProjectProcessForm.description
                }
              }
              await this.POST_PROJECT_PROCESS(payload)

              this.REMOVE_CACHED_DROPDOWN('projectProcesses')

              this.$refs[refName].resetFields()
              this.closeNewProcessPopover()
              this.loading = false
              this.$message({
                message: 'Process Added',
                type: 'success'
              })
            } catch (err) {
              this.loading = false
              this.$message({
                message: `Error Adding Process: ${err.message}`,
                type: 'error'
              })
            }
          }
        })
      },
      async updateProcess(process) {
        const index = this.projectProcessesList.findIndex(x => x.processId === process.processId)
        this.$set(this.projectProcessesList, index, process)

        try {
          this.loading = true
          await this.PUT_PROJECT_PROCESS(process)
          this.REMOVE_CACHED_DROPDOWN('projectProcesses')
          this.loading = false
          this.$message({
            message: 'Process Saved',
            type: 'success'
          })
        } catch (err) {
          this.loading = false
          this.$message({
            message: `Error Editing Process: ${err.message}`,
            type: 'error'
          })
        }
      },
      async deleteProcess(process) {
        await this.$confirm(`Permanently delete ${process.name}?`, 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })

        try {
          this.loading = true
          await this.DELETE_PROJECT_PROCESS(process)
          this.REMOVE_CACHED_DROPDOWN('projectProcesses')
          this.loading = false
          this.$message({
            message: 'Process Deleted Successfully',
            type: 'success'
          })
        } catch (err) {
          this.loading = false
          this.$message({
            message: `Error Deleting Process: ${err.message}`,
            type: 'error'
          })
        }
      }
    },
    computed: {
      ...mapState('managedLists/clients/', ['clientList']),
      ...mapState('managedLists/projectProcesses/', ['projectProcessesList', 'projectProcessListLoading']),
      ...mapState('user/', ['currentTenantGuid'])
    },
    watch: {
      currentTenantGuid() {
        this.initialize(this.$route)
      }
    },
    created: function() {
      this.initialize(this.$route)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .taskOption {
    cursor: pointer;
    padding: 0px 20px 0px 20px;
    color: #337ab7;
  }

  .taskOption:hover {
    background: rgba(255, 196, 12, 0.2);
    border-radius: 2px;
  }

  .selected {
    background: rgba(255, 196, 12, 0.2);
  }

  .topMargin {
    margin: 10px 0px 0px 0px;
  }

  >>> .drilldown {
    min-width: 200px;
  }

  .drilldown-cell {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  }

  .drilldown-toggle {
    color: #337ab7;
    cursor: pointer;
    line-height: 1;
  }

  .drilldown-tag {
    padding: 5px 5px 15px;
    cursor: pointer;
  }

  >>> .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  >>> .VueTables__child-row-toggler--closed::before {
    content: '+';
  }

  >>> .VueTables__child-row-toggler--open::before {
    content: '-';
  }
</style>
